import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken, LOGIN_PATH } from '@noor/api';
import { ResetPasswordPage } from '@/pages/reset-password';

export const Route = createFileRoute('/reset-password')({
  beforeLoad: () => {
    // Already signed in → there is nothing to recover. Mirrors `/login`'s own
    // guard so a signed-in merchant can never land on a public auth screen.
    // (Changing a KNOWN password is a different action and belongs in the
    // account settings, behind the session, not here.)
    if (readAuthToken()) {
      // `redirect()` is TanStack Router's control-flow throw, not an Error.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/welcome' });
    }
  },
  component: ResetPasswordRoute,
});

/**
 * Public password-recovery screen (full-bleed, no app shell — see `__root.tsx`).
 *
 * On success it returns to `/login` rather than signing the merchant in:
 * `set-password` issues no tokens, and there is no session to enter with. The
 * merchant uses the password they just chose on the login screen.
 */
function ResetPasswordRoute() {
  const navigate = useNavigate();

  return <ResetPasswordPage onCompleted={() => void navigate({ to: LOGIN_PATH })} />;
}
